import { useState } from "react";
import { extractOrderItems, getStudentName } from "../utils/StringUtils";
import { formatCurrency } from "../utils/CurrencyUtils";
import ModalPortal from "./lib/modalPortal";

const DetailsModal = ({ details }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                className="bg-gray-200 w-24 h-8 flex items-center justify-center rounded mt-1"
                onClick={() => setOpen(true)}
            >
                Detalhes
            </button>

            {open && (
                <ModalPortal>
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                        onClick={() => setOpen(false)}
                    >
                        <div
                            className="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full relative"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <h2 className="text-lg font-bold mb-4">Detalhes</h2>

                            <div className="space-y-4 max-h-[60vh] overflow-y-auto">
                                {details.map((d, idx) => (
                                    <div
                                        key={idx}
                                        className="p-3 border rounded-md shadow-sm bg-gray-50"
                                    >
                                        <div className="flex justify-between mb-1">
                                            {d.orderId && (
                                                <p className="font-semibold">Pedido #{d.orderId}</p>
                                            )}
                                            {d.clientId && (
                                                <p>Aluno: {getStudentName(d.clientId)}</p>
                                            )}
                                        </div>

                                        {d.itemsList && (
                                            <div className="mb-2">
                                                <p className="font-semibold">Itens:</p>
                                                <ul className="list-disc list-inside text-sm">
                                                    {extractOrderItems(d.itemsList).map(
                                                        (itemDetail, i) => (
                                                            <li key={i}>
                                                                {itemDetail.name} x{itemDetail.quantity}
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </div>
                                        )}

                                        <p className="font-semibold">
                                            Valor: {formatCurrency(d.totalValue)}
                                        </p>
                                    </div>
                                ))}
                            </div>

                            <button
                                className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
                                onClick={() => setOpen(false)}
                            >
                                ✕
                            </button>
                        </div>
                    </div>
                </ModalPortal>
            )}
        </>
    );
};

export default DetailsModal;
